module.exports = __webpack_public_path__ + "static/media/background.f81f17d8.svg";